/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeModel } from '../../models/employee-model';

export interface GetAttorney$Plain$Params {

/**
 * id of attorney for filter
 */
  attorneyId: number;
}

export function getAttorney$Plain(http: HttpClient, rootUrl: string, params: GetAttorney$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<EmployeeModel>> {
  const rb = new RequestBuilder(rootUrl, getAttorney$Plain.PATH, 'get');
  if (params) {
    rb.path('attorneyId', params.attorneyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmployeeModel>;
    })
  );
}

getAttorney$Plain.PATH = '/api/Attorney/{attorneyId}';
